@if (!isFromQuickstartRentUnit) {
  <div class="prospect_top_sec">
    <h5 class="prospectsHeader">Demographic</h5>
  </div>
}
<div class="row mx-0">
  <div class="row mx-0 w-100">
    <app-call-script [section]="section" style="width: 100%;"></app-call-script>
  </div>
  <div class="demographic_outer">
    @for (item of demographicList; track item) {
      <div class="demographic_list">
        <h1>{{item.DisplayOrder}}. {{item.Question}}</h1>
        <div class="selectbox_option">
          @if (item.isDemographic) {
            <select class="form-select"
              (change)="onSelectOption($event.target.value, item)">
              <option value="0">Select</option>
              @for (option of item.Option; track option) {
                <option [value]="option.OptionId" [selected]="option.selected">
                {{option.Option}}</option>
              }
            </select>
          }
        </div>
        @if (!item.isDemographic) {
          <div class="checkbox_out">
            @for (option of item.Option; track option) {
              <div class="checkbox_option">
                <label class="pure-material-checkbox">
                  <input type="checkbox" [(ngModel)]="option.checked" (change)="optionChecked($event,option)">
                  <span>{{option.Option}}</span>
                </label>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="bottom_button mt-3">
  <button type="button" class="btn btn-outline-primary me-3" i18n="@@Cancel"
  (click)="cancelDemographic(template1)">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!isDirty" (click)="saveDemographic()">Save</button>
</div>

<ng-template #template1>
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ptb24">
    <p class="m-0" i18n="@@Are_you_sure_you_want_to_discard_the_changes ?">
            Are you sure you want to cancel? Any data modifications will not be saved
        </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef.hide()" i18n="@@No">No</button>
    <button class="btn btn-primary" type="button" (click)="HideDemographic()" i18n="@@Yes">Yes</button>
  </div>
</ng-template>